import React from 'react';
import { LogIn, Target, Info, ExternalLink, ArrowLeft } from 'lucide-react';
import { hikersHeroBgStyle } from '../constants/backgrounds';

const MemberLoginPage = () => {
  return (
    <div
      className="min-h-screen text-stone-900 relative"
      style={hikersHeroBgStyle}
      data-testid="member-login-page"
    >
      {/* Back to Build Nutrition Banner */}
      <div className="bg-stone-200/90 backdrop-blur-sm border-b border-stone-300">
        <div className="max-w-5xl mx-auto px-4">
          <a
            href="https://buildnutrition.ca/"
            className="flex items-center gap-1.5 py-2 text-stone-700 hover:text-[#B8871E] transition-colors text-sm font-semibold w-fit"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Build Nutrition Home Page
          </a>
        </div>
      </div>

      {/* Hero */}
      <section className="relative py-14 md:py-20 px-4">
        <div className="max-w-4xl mx-auto relative text-center">
          <p className="text-[#EFB342] uppercase tracking-[0.2em] text-xs md:text-sm font-semibold mb-4">RxGRIT by BUILD Nutrition</p>
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-stone-900 leading-tight mb-4 uppercase tracking-tight">
            RxGRIT Login
          </h1>
          <p className="text-stone-600 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Welcome back. Access your challenge app and resources below.
          </p>
        </div>
      </section>

      {/* Three Boxes */}
      <section className="px-4 pb-20">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">

          {/* Box 1: Login to Challenge App */}
          <a
            href="https://rxgrit.buildnutrition.ca/login"
            className="bg-white border border-stone-200 rounded-3xl p-6 sm:p-8 hover:border-[#EFB342] hover:-translate-y-1 hover:shadow-lg transition-all duration-300 group flex flex-col"
            data-testid="member-login-challenge-app-card"
          >
            <div className="w-14 h-14 bg-[#EFB342]/15 border border-[#EFB342]/25 rounded-2xl flex items-center justify-center mb-5">
              <LogIn className="text-[#B8871E]" size={28} />
            </div>
            <h3 className="font-heading text-xl font-bold text-stone-900 mb-3 leading-tight group-hover:text-[#B8871E] transition-colors">
              Login to the RxGRIT App
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed flex-1">
              Track your daily habits, collect points, climb the leaderboard, and connect with the community — all inside your RxGRIT app.
            </p>
            <span className="inline-flex items-center gap-1.5 text-[#B8871E] text-sm mt-5 font-semibold group-hover:underline">
              Open RxGRIT App <ExternalLink size={14} />
            </span>
          </a>

          {/* Box 2: Other Resources Note */}
          <div className="bg-[#F0EBE1] border border-stone-200 rounded-3xl p-6 sm:p-8 flex flex-col">
            <div className="w-14 h-14 bg-[#EFB342]/15 border border-[#EFB342]/25 rounded-2xl flex items-center justify-center mb-5">
              <Info className="text-[#B8871E]" size={28} />
            </div>
            <h3 className="font-heading text-xl font-bold text-stone-900 mb-3 leading-tight">
              All the extras inside RxGRIT
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed flex-1">
              Direct links to the <span className="text-stone-900 font-medium">Resource Toolbox</span> (meal plans, workouts &amp; more), <span className="text-stone-900 font-medium">50% off 1:1 nutrition coaching</span>, and the searchable <span className="text-stone-900 font-medium">RECIPE DATABASE</span> — all inside the app.
            </p>
            <a
              href="https://rxgrit.buildnutrition.ca/login"
              className="inline-flex items-center gap-1.5 text-[#B8871E] text-sm mt-5 font-semibold hover:underline"
              data-testid="member-login-extras-card-cta"
            >
              Open RxGRIT App <ExternalLink size={14} />
            </a>
          </div>

          {/* Box 3: Free Macro Tracking App */}
          <a
            href="https://buildnutrition.ca/pb-free-tracking-app"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white border border-stone-200 rounded-3xl p-6 sm:p-8 hover:border-[#EFB342] hover:-translate-y-1 hover:shadow-lg transition-all duration-300 group flex flex-col"
            data-testid="member-login-macro-app-card"
          >
            <div className="w-14 h-14 bg-[#EFB342]/15 border border-[#EFB342]/25 rounded-2xl flex items-center justify-center mb-5">
              <Target className="text-[#B8871E]" size={28} />
            </div>
            <h3 className="font-heading text-xl font-bold text-stone-900 mb-3 leading-tight group-hover:text-[#B8871E] transition-colors">
              Free macro tracking app
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed flex-1">
              Open to all, <span className="text-[#B8871E] font-semibold">RxGRIT membership NOT required.</span> A powerful (and free) tool for tracking your macros if you want extra clarity and precision.
            </p>
            <span className="inline-flex items-center gap-1.5 text-[#B8871E] text-sm mt-5 font-semibold group-hover:underline">
              Get /log in to the tracking app <ExternalLink size={14} />
            </span>
          </a>

        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-stone-200/70 bg-white/40 backdrop-blur-sm py-8 px-4 text-center">
        <p className="text-stone-500 text-sm">&copy; {new Date().getFullYear()} BUILD Nutrition. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default MemberLoginPage;
